import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <footer
          id="main-footer"
          className="add-padding bg-color3 border-top-color"
        >
          <div className="container">
            <ul className="social-links text-center">
              <li>
                <a
                  href="https://instagram.com/shawnydouglas?igshid=k54xwt1nsmiu"
                  target="_blank"
                >
                  <i className="fa fa-instagram fa-fw"></i>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/shawnydouglas/">
                  <i className="fa fa-facebook fa-fw"></i>
                </a>
              </li>
            </ul>

            <p className="text-center">Shawn Douglas Hair</p>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
export default Footer;
